import { Suspense, useEffect, useState } from "react";
import { Insureframe } from "../components/Insureframe/Insureframe";
import Loader from "../common/Loader/Loader";

export default function HousePage() {
  const broker = import.meta.env.VITE_BROKER;
  const [data, setData] = useState();

  useEffect(() => {
    async function fetchData() {
      const data = await import(
        `../data/${broker.toLowerCase()}/markdowns/terms.md?raw`
      );

      setData(data.default);
    }

    fetchData();
  }, [broker]);

  if (!data) {
    return <Loader />;
  }

  return (
    <>
      <section className="relative overflow-hidden pb-150 pt-[150px] max-md:pt-150">
        <div className="container">
          <Suspense>
            <Insureframe
              terms={data}
              product="house"
              insureframeUrl={import.meta.env.VITE_INSUREFRAME_URL}
              insureframeApiKey={import.meta.env.VITE_INSUREFRAME_APIKEY}
              insureframeCutomUrl={import.meta.env.VITE_INSUREFRAME_CUSTOM_URL}
            />
          </Suspense>
        </div>
      </section>
    </>
  );
}
